import { dew as _DefaultVideoCaptureAndEncodeParameterDew } from "../videocaptureandencodeparameter/DefaultVideoCaptureAndEncodeParameter";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  // SPDX-License-Identifier: Apache-2.0
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const DefaultVideoCaptureAndEncodeParameter_1 = __importDefault(_DefaultVideoCaptureAndEncodeParameterDew());
  class NoVideoUplinkBandwidthPolicy {
    constructor() {}
    updateConnectionMetric(_metrics) {}
    chooseMediaTrackConstraints() {
      return {};
    }
    chooseEncodingParameters() {
      return new Map();
    }
    updateIndex(_videoIndex) {}
    wantsResubscribe() {
      return false;
    }
    chooseCaptureAndEncodeParameters() {
      return new DefaultVideoCaptureAndEncodeParameter_1.default(0, 0, 0, 0, false);
    }
    maxBandwidthKbps() {
      return 0;
    }
    setIdealMaxBandwidthKbps(_idealMaxBandwidthKbps) {}
    setHasBandwidthPriority(_hasBandwidthPriority) {}
    setHighResolutionFeatureEnabled(_enabled) {}
    wantsVideoDependencyDescriptorRtpHeaderExtension() {
      return false;
    }
  }
  exports.default = NoVideoUplinkBandwidthPolicy;
  //# sourceMappingURL=NoVideoUplinkBandwidthPolicy.js.map
  return exports;
}